import { ApiClient } from '@/lib/apiClient';
import type { CreateClientLog, ClientLog } from '@/types/clientLog';

export default class ClientLogService extends ApiClient<ClientLog, CreateClientLog> {

  constructor() {
    super('/v1/clientlog', 'id');
  }
}
